function ComingSoon(){
    return (
      <div class="ComingSoon">
        <h1>Coming Soon</h1>
      </div>
    )
    }
    
export default ComingSoon;